var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEqual3XDesktop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 450,
    height: 210
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "equal_3x_desktop_svg__a",
    x1: 0.965,
    y1: 0.5,
    x2: -0.02,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#158462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68c181"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 7211"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1892",
    fill: "url(#equal_3x_desktop_svg__a)",
    d: "M0 0h449.999v210H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 7253"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3995",
    d: "M388.333 105a263.96 263.96 0 01-22 105h83.669V0h-83.671a263.96 263.96 0 0122.002 105z",
    fill: "#158462"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3996",
    d: "M366.331 0h-86.743c17.36 32.549 26.9 67.958 26.9 105s-9.541 72.451-26.9 105h86.743a261.546 261.546 0 000-210z",
    fill: "#17936f"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3997",
    d: "M279.588 0h-93.716c22.483 31.392 35.218 67.106 35.218 105s-12.735 73.607-35.218 105h93.716c17.36-32.549 26.9-67.959 26.9-105s-9.54-72.451-26.9-105z",
    fill: "#209e6e"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3998",
    d: "M185.872 0h-100.6c32.209 28.533 51.558 65.114 51.558 105s-19.349 76.467-51.558 105h100.6c22.483-31.393 35.218-67.106 35.218-105S208.355 31.392 185.872 0z",
    fill: "#3faf77"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3999",
    d: "M85.27 0H0v16.232C37.332 36.256 61.585 68.551 61.585 105S37.332 173.744 0 193.768V210h85.27c32.209-28.533 51.558-65.114 51.558-105S117.479 28.533 85.27 0z",
    fill: "#68c181"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4000",
    d: "M61.585 105c0-36.449-24.253-68.744-61.585-88.768v177.536C37.332 173.744 61.585 141.449 61.585 105z",
    fill: "#7cce87"
  })))));
}

export default __webpack_public_path__ + "static/media/equal_3x_desktop.bb96857c64edce69eff30b7764c33c93.svg";
export { SvgEqual3XDesktop as ReactComponent };